import $ from 'jquery';
import _ from 'underscore';
import branch from 'branch-sdk';
import wafer from 'lib/wafer';
import analytics from 'util/analytics';
import { $body, jqGetElemById, isAndroidWeb, isIosWeb } from 'util/global';

// THIS SHOULD ALWAYS BE false UNLESS TESTING
var DEBUG = false;

var branchModule = {};

var sessionid = null;
var branchEnabled = true;

let $activeBanner = null;

var btoa =
  window.btoa ||
  function (str) {
    // not super important, just make it look like something else
    return str
      .split('')
      .map(function (item) {
        return item.charCodeAt(0);
      })
      .join('');
  };

branchModule.disable = function () {
  branchEnabled = false;
};

/**
 * Load Branch SDK and maybe show the Branch banner
 * @param {JQuery} $container
 */
branchModule.init = function ($container) {
  // include branch sdk

  var options = $container.data();

  sessionid = btoa(analytics.superProperties.sessionid || 'unknown');

  // init the branch sdk
  branch.init(options.branchKey, function (err, data) {
    if (!err) {
      // set the identity; try/catch in case it doesn't exist for some reason
      try {
        branch.setIdentity(analytics.identity);
      } catch (e) {}

      var hasApp = data && data.has_app === true;
      analytics.setSuperProperties({
        branch_has_app: hasApp,
      });

      if (!hasApp) {
        var linkOptions = {
          channel: 'mobile-web',
          data: {
            $deeplink_path: window.location.pathname + window.location.search,
            $always_deeplink: true,
          },
        };
        branch.link(linkOptions, function (err, link) {
          if (err || !branchEnabled) {
            return;
          }
          if (options.showBanner) {
            showBanner(link, hasApp);
          }
        });
      }
    }
  });
};

/**
 * Get the localStorage key an element type
 * @param {String} type - (banner|modal)
 */
function getStorageKey(type) {
  return analytics.identity + '_brilliant-branch-' + type;
}

/**
 * Store the state value for an element type
 * @param {String} type - (banner|modal)
 * @param {String} value
 */
function setStorageItem(type, value) {
  wafer.set(getStorageKey(type), sessionid + ':' + value);
}

/**
 * Get the state value for an element type
 * @param {String} type - (banner|modal)
 */
function getStorageItem(type) {
  var value = wafer.get(getStorageKey(type));
  if (value) {
    value = value.split(':');
    if (sessionid === value[0]) {
      return value[1];
    }
  }
  return null;
}

function hideActiveBanner() {
  if ($activeBanner) {
    $body.removeClass('branch-banner-active');
    $activeBanner.removeClass('in');
    $activeBanner = null;
  }
}

branchModule.hideBranchBanner = () => hideActiveBanner();

/**
 * Show the Branch banner
 * @param {String} link
 * @param {Boolean} hasApp
 */
function showBanner(link, hasApp) {
  const storageValue = getStorageItem('banner');
  if (storageValue === 'closed' && !DEBUG) {
    return;
  }

  const template = _.template(jqGetElemById('branch-banner-tmpl').text());
  const $banner = $(
    template({
      link,
      hasApp,
      isIosWeb,
      isAndroidWeb,
    }),
  );

  $body.addClass('branch-banner-active').append($banner);

  analytics.setAnalyticsEvents($banner);

  setTimeout(() => {
    $banner.addClass('in');
  }, 1000);

  $banner.find('.close').on('click', () => hideActiveBanner());

  $banner.find('button,a').on('click', () => {
    setStorageItem('banner', 'closed');
  });

  $activeBanner = $banner;
}

module.exports = branchModule;
